// ¿La plantilla que está abierta elige Calidad (1K / 2K / 4K)?
// ADR-2026-09-28-las-plantillas-eligen-la-calidad.
//
// Una sola regla para los cuatro lugares que la necesitan —la celda del pie
// (`ConfigurePanel`), el multiplicador del pill (`PresetDetailSheet`), el `image_size`
// del payload y el del carrusel de la producción (`InterfazV2`)—: si uno la mira distinto
// que otro, el pill dice un precio y el backend cobra otro.
//
// También las de "Fondo blanco" (poses `design` y vistas solo-producto `design-producto`)
// desde ADR-2026-10-12-fondo-blanco-como-las-plantillas: usan el mismo sheet y el backend
// ya respetaba `image_size` en su pedido; se habían dejado en 1K sólo porque no se pidió.
//
// Sólo las plantillas de IMAGEN. La de video corre sobre Kling, que no tiene resolución
// de imagen que elegir; y la de imagen con la pestaña "Video" genera un cuadro que después
// se anima, así que pagar 4K por ese cuadro no mejora el video.

export function plantillaEligeCalidad(
  preset: { kind?: string | null; outputType?: string | null } | null | undefined,
  /** La pestaña "Video" de la plantilla (`previewMediaTab === 'video'`). */
  modoVideo: boolean,
): boolean {
  const kind = preset?.kind;
  if (kind === 'design' || kind === 'design-producto') return true;
  return kind === 'template' && preset?.outputType !== 'video' && !modoVideo;
}
